import { render, staticRenderFns } from "./MenuCatalogoItens.vue?vue&type=template&id=124f780e"
import script from "./MenuCatalogoItens.vue?vue&type=script&lang=js"
export * from "./MenuCatalogoItens.vue?vue&type=script&lang=js"
import style0 from "./MenuCatalogoItens.vue?vue&type=style&index=0&id=124f780e&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports